import styled from "@emotion/styled"
import { leadingNormal, typescaleSm } from "@porsche-design-system/components-react/emotion"
import { SkeletonComponent } from "./SkeletonComponent"

interface SkeletonButtonRoundProps {
	className?: string
}

export const SkeletonButtonRound = ({ className }: SkeletonButtonRoundProps) => <Box className={className} />

const Box = styled(SkeletonComponent)`
	font-size: ${typescaleSm};
	height: ${leadingNormal};
	aspect-ratio: 1 / 1;
	border-radius: 50%;
`
